import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const useLinkStyles = makeStyles((theme: Theme) =>
  createStyles({
    common: {
      paddingBottom: "4px",
      cursor: "pointer",
      "&:hover": {
        textDecoration: "none",
        paddingBottom: "2px",
        borderBottom: `2px solid ${theme.palette.common.white}`,
      },
    },
    active: {
      textDecoration: "none",
      paddingBottom: "2px",
      borderBottom: `2px solid ${theme.palette.common.white}`,
    },
    disabled: {
      opacity: 0.6,
    },
  }),
);
